import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { Field } from 'redux-form';
import ReactDOM from 'react-dom';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { InputField, DisabledInputField } from '../../components/Common/inputField';

class CashOutModal extends Component {
    constructor() {
      super();
      this.state = {
        moduleValues: {
          TotalCashAmount: 0,
          PaidOutByCash: 0,
          StoreCredit: 0,
          CreditCards: 0,
          Checks: 0,
          TotalSale: 0,
          TotalPaidOut: 0,

          CountedCash: 0,
          CountedStoreCredit: 0,
          CountedCard: 0,
          CountedCheck: 0,
          TotalCounted: 0,
          Balance: 0,

          NumCardTransaction: 0,
          NumCheck: 0,
        }
      };
    }

    componentWillMount() {
      const {
        TotalCashAmount,
        PaidOutByCash,
        StoreCredit,
        CreditCards,
        Checks,
        TotalSale,
        TotalPaidOut,

        CountedCash,
        CountedStoreCredit,
        CountedCard,
        CountedCheck,
        TotalCounted,
        Balance,

        NumCardTransaction,
        NumCheck,
      } = this.props.rowProps;
      this.setState ({
        moduleValues: {
          TotalCashAmount: parseFloat(TotalCashAmount,10),
          PaidOutByCash: parseFloat(PaidOutByCash,10),
          StoreCredit: parseFloat(StoreCredit,10),
          CreditCards: parseFloat(CreditCards,10),
          Checks: parseFloat(Checks,10),
          TotalSale: parseFloat(TotalSale,10),
          TotalPaidOut: parseFloat(TotalPaidOut,10),

          CountedCash: 0,
          CountedStoreCredit: 0,
          CountedCard: 0,
          CountedCheck: 0,
          TotalCounted: parseFloat(TotalCounted,10),
          Balance: parseFloat(Balance,10),

          NumCardTransaction: parseFloat(NumCardTransaction,10),
          NumCheck: parseFloat(NumCheck,10),
        }
      });
    }

    componentWillReceiveProps(nextProps) {
      let newValues = { ...this.state };
      const {
        TotalSale,
        TotalPaidOut,
        CountedCash,
        CountedStoreCredit,
        CountedCard,
        CountedCheck,
      } = this.state.moduleValues;
      newValues.moduleValues.TotalCounted = parseFloat(CountedCash,10) + parseFloat(CountedStoreCredit,10) + parseFloat(CountedCard,10) + parseFloat(CountedCheck,10);
      newValues.moduleValues.Balance = newValues.moduleValues.TotalCounted - (parseFloat(TotalSale,10) - parseFloat(TotalPaidOut,10));
      this.setState({ newValues });
    }

    submitFields = () => {
      const {
        CountedCash,
        CountedStoreCredit,
        CountedCard,
        CountedCheck,
        TotalCounted,
        Balance,
        NumCardTransaction,
        NumCheck,
      } = this.state.moduleValues;
      const updatedField = {
        CountedCash,
        CountedStoreCredit,
        CountedCard,
        CountedCheck,
        TotalCounted,
        Balance,
        NumCardTransaction,
        NumCheck,
      }
      this.props.verifyRegisters(this.props.rowProps.Session_id, updatedField);
      this.props.finishedSubmit();
    }

    handleInputChange = (e) => {
      let moduleValues = { ...this.state.moduleValues };
      if (typeof parseFloat(e.target.value, 10) !== 'NaN') {
        moduleValues[e.target.name] = parseFloat(e.target.value, 10);
        moduleValues.TotalCounted = parseFloat(moduleValues.CountedCash,10) + parseFloat(moduleValues.CountedStoreCredit, 10) + parseFloat(moduleValues.CountedCard, 10) + parseFloat(moduleValues.CountedCheck, 10);
        moduleValues.Balance = moduleValues.TotalCounted - (parseFloat(moduleValues.TotalSale, 10) - parseFloat(moduleValues.TotalPaidOut, 10));
        this.setState({ moduleValues });
      }
    }

    render() {
      const {
        TotalCashAmount,
        PaidOutByCash,
        StoreCredit,
        CreditCards,
        Checks,
        TotalSale,
        TotalPaidOut,

        CountedCash,
        CountedStoreCredit,
        CountedCard,
        CountedCheck,
        TotalCounted,
        Balance,

        NumCardTransaction,
        NumCheck,
      } = this.props.rowProps;
      return (
        <ContentWrapper>
          <Grid id='cash-out-modal' fluid>
            <Row>
              <Col xs={12}>
                <Row>
                  <div className='col-xs-5ths'>
                    <Translate value="cash" />
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="cash_total" />
                      </Col>
                      <Col xs={6}>
                        <Field name='TotalCashAmount' component={DisabledInputField} placeholder={TotalCashAmount}/>
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="cash_paid_out" />
                      </Col>
                      <Col xs={6}>
                        <Field name='PaidOutByCash' component={DisabledInputField} placeholder={PaidOutByCash} />
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="counted_cash" />
                      </Col>
                      <Col xs={6}>
                        <Field name='CountedCash' type='number' component={InputField} onChange={this.handleInputChange} />
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>

                  </div>
                </Row>
                {/* ================== Row TWO ================== */}
                <Row>
                  <div className='col-xs-5ths'>
                    <Translate value="store_credits" />
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="store_credit" />
                      </Col>
                      <Col xs={6}>
                        <Field name='StoreCredit' component={DisabledInputField} placeholder={StoreCredit} />
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>

                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="counted_store_credit" />
                      </Col>
                      <Col xs={6}>
                        <Field name='CountedStoreCredit' type='number' component={InputField} onChange={this.handleInputChange} />
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>

                  </div>
                </Row>
                {/* ================== Row THREE ================== */}
                <Row>
                  <div className='col-xs-5ths'>
                    <Translate value="cards" />
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="card_total" />
                      </Col>
                      <Col xs={6}>
                        <Field name='CreditCards' component={DisabledInputField} placeholder={CreditCards}/>
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>

                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="counted_card" />
                      </Col>
                      <Col xs={6}>
                        <Field name='CountedCard' type='number' component={InputField} onChange={this.handleInputChange} />
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>

                  </div>
                </Row>
                {/* ================== Row FOUR ================== */}
                <Row>
                  <div className='col-xs-5ths'>
                    <Translate value="checks" />
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="check_total" />
                      </Col>
                      <Col xs={6}>
                        <Field name='Checks' component={DisabledInputField} placeholder={Checks}/>
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>

                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="counted_check" />
                      </Col>
                      <Col xs={6}>
                        <Field name='CountedCheck' type='number' component={InputField} onChange={this.handleInputChange} />
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>

                  </div>
                </Row>
                {/* ================== Row FIVE ================== */}
                <Row>
                  <div className='col-xs-5ths'>
                    <Translate value="total" />
                  </div>
                  <div className='col-xs-5ths'>

                  </div>
                  <div className='col-xs-5ths'>

                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="total_count" />
                      </Col>
                      <Col xs={6}>
                        <Field name='TotalCounted' component={DisabledInputField} onChange={this.handleInputChange} placeholder={this.state.moduleValues.TotalCounted} />
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="balance" />
                      </Col>
                      <Col xs={6}>
                        <Field name='Balance' component={DisabledInputField} onChange={this.handleInputChange} placeholder={this.state.moduleValues.Balance} />
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths' />
                </Row>
                {/* ================== Row SIX ================== */}
                <Row>
                  <div className='col-xs-5ths'>
                    <Translate value="balance" />
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="total_sale" />
                      </Col>
                      <Col xs={6}>
                        <Field name='TotalSale' component={DisabledInputField} placeholder={TotalSale} />
                      </Col>
                    </Row>
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Translate value="total_paid_out" />
                      </Col>
                      <Col xs={6}>
                        <Field name='TotalPaidOut' component={DisabledInputField} placeholder={TotalPaidOut} />
                      </Col>
                    </Row>
                  </div>
                </Row>
                {/* Row 7 */}
                <Row>
                  <div className='col-xs-5ths' />
                  <div className='col-xs-5ths' />
                  <div className='col-xs-5ths'>
                    <Translate value="number_of_card_transactions" />
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Field name='NumCardTransaction' type='number' component={InputField} onChange={this.handleInputChange} />
                      </Col>
                    </Row>
                  </div>
                </Row>
                <Row>
                  <div className='col-xs-5ths' />
                  <div className='col-xs-5ths' />
                  <div className='col-xs-5ths'>
                    <Translate value="number_of_checks" />
                  </div>
                  <div className='col-xs-5ths'>
                    <Row>
                      <Col xs={6}>
                        <Field name='NumChecks' type='number' component={InputField} onChange={this.handleInputChange} />
                      </Col>
                    </Row>
                  </div>
                </Row>
                <Row/>
                <Row>
                  <Col xs={6} />
                  <Col xs={6} />
                  <Col xs={6} />
                  <div className='col-xs-4ths'>
                    <Button onClick={this.submitFields} >Submit</Button>
                  </div>
                </Row>
              </Col>
            </Row>
          </Grid>
        </ContentWrapper>
      )
    }
}

export default CashOutModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/cashOutModal.jsx